<div class="loader">
  <ng-container>{{ helper.translate('Loading') }}</ng-container>
</div>
